'use client';

import React from 'react';
import GfProviderCard from '@/components/common/GfProviderCard';

// Internal link to the provider detail page (no affiliate mechanics here) —
// тонкий адаптер над общим GfProviderCard (.pc) с кликабельным корнем <Link href>
// и статичным футером «Подробнее →». Раньше дублировал всю .pc-разметку.
export default React.memo(function StayProviderCard({
    provider,
    lang = 'ru',
    countrySlug,
    _countryName,
    _countryData,
    _affiliateProvider,
    className = '',
}) {
    if (!provider) return null;

    const isRu = lang === 'ru';
    const normalizedCountry = typeof countrySlug === 'string' && countrySlug.length > 0 ? countrySlug : null;
    const href = normalizedCountry
        ? `/${lang}/${normalizedCountry}/stay/${provider.code}`
        : `/${lang}/stay/${provider.code}`;

    const title = provider.title || provider.name || '';
    const description = isRu
        ? (provider.descriptionRu || provider.descriptionEn || 'Сервис бронирования жилья')
        : (provider.descriptionEn || provider.descriptionRu || 'Accommodation booking service');

    const logoSrc = provider.logoUrl
        || (provider.code ? `/images/providers/${provider.code}.svg` : '/images/providers/default.svg');

    return (
        <GfProviderCard
            name={title}
            logo={logoSrc}
            logoAlt={provider.logoAlt}
            description={description}
            href={href}
            className={className}
        >
            <span className="visit">{isRu ? 'Подробнее →' : 'Details →'}</span>
        </GfProviderCard>
    );
});
